import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerSimilarPartner} from './partnerGetSimilarPartners.result';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PartnerSummaryConverter} from '../../converter/partnerSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class PartnerSimilarPartnersConverter extends HttpModelConverter<PartnerSimilarPartner> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): PartnerSimilarPartner {
        return new PartnerSimilarPartner();
    }

    protected enrichObject(result: PartnerSimilarPartner, src: PartnerSimilarPartner) {
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.reason = this.lovValueSummaryConverter.convert(src.reason);
    }

}
